import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { getLiveChatTemplate } from "@/assets/utilities/tinymce/shortcodes/templates";
import { parseToHtml } from "@/utility/parseToHtml";
import { serializeDynamicComponents, visualizeDynamicComponents } from "@/assets/utilities/tinymce/visualization";
import { convertAssetsPathToRelativeLinks } from "@/utility/convertAssetsPaths";
import { traverseTree } from "@/utility/traverseTree";

function serializeContent(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => serializeContent(item));
  } else {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (key === "content") {
        const content = parseToHtml(obj[key]);
        serializeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else if (key === "text") {
        const content = parseToHtml(obj[key]);
        serializeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else {
        newObj[key] = serializeContent(obj[key]);
      }
    });

    return newObj;
  }
}

function visualizeContent(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => visualizeContent(item));
  } else {
    const newObj = {};
    Object.keys(obj).forEach(key => {
      if (key === "content") {
        const content = parseToHtml(obj[key]);
        visualizeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else if (key === "text") {
        const content = parseToHtml(obj[key]);
        visualizeDynamicComponents(content);
        newObj[key] = content.body.innerHTML;
      } else {
        newObj[key] = visualizeContent(obj[key]);
      }
    });

    return newObj;
  }
}

const editLiveChatConfig = (editor, shortcodeWrapper) => {
  let currentData = null;

  const liveChatWindow = editor.windowManager.openUrl({
    title: "Live Chat",
    url: "/live-chat-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance, message) {
      editor.windowManager.alert("Success!");
      traverseTree(currentData.messages, message => {
        if (message.content) {
          message.content = convertAssetsPathToRelativeLinks(message.content)?.body?.innerHTML;
        }

        if (message.text) {
          message.text = convertAssetsPathToRelativeLinks(message.text)?.body?.innerHTML;
        }

        if (message.value) {
          message.value = convertAssetsPathToRelativeLinks(message.value)?.body?.innerHTML;
        }
      });
      const serializedData = serializeContent(currentData);
      const encodedData = btoa(unescape(encodeURIComponent(JSON.stringify(serializedData))));

      shortcodeWrapper.setAttribute("data-live-chat-data", encodedData);
      // We have to call change function here to updateMainContent in form component
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === "requestData") {
        sendData();
      }

      if (message.mceAction === "updateLiveChatData") {
        currentData = message.data;
      }
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });

  const sendData = () => {
    const liveChatShortcodeData = shortcodeWrapper.getAttribute("data-live-chat-data");
    const parsedData = JSON.parse(decodeURIComponent(escape(window.atob(liveChatShortcodeData))));
    const content = visualizeContent(parsedData);

    liveChatWindow.sendMessage({
      type: "sendData",
      data: content,
    });
  };
};

const liveChatConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;

  tinymce.activeEditor.windowManager.openUrl({
    title: "Live Chat",
    url: "/live-chat-dialog?data=null",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getLiveChatTemplate(),
        "live-chat-shortcode",
      );

      traverseTree(currentData.messages, message => {
        if (message.content) {
          message.content = convertAssetsPathToRelativeLinks(message.content)?.body?.innerHTML;
        }

        if (message.text) {
          message.text = convertAssetsPathToRelativeLinks(message.text)?.body?.innerHTML;
        }

        if (message.value) {
          message.value = convertAssetsPathToRelativeLinks(message.value)?.body?.innerHTML;
        }
      });

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      const serializedData = serializeContent(currentData);
      const encodedData = btoa(unescape(encodeURIComponent(JSON.stringify(serializedData))));

      shortcodeWrapperEl.setAttribute("data-live-chat-data", encodedData);

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);
      instance.close();
    },
    onMessage: (instance, message) => {
      currentData = message.data;
    },
    width: window.innerWidth - 20,
    height: window.innerHeight - 20,
  });
};

export { liveChatConfig, editLiveChatConfig };
